import React from "react";
import "../../css/insightsView.css";
import "../../css/insightsOneView.css";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import { insightsConstants } from "../../constant/insights_constants";
import { DropdownButton, MenuItem } from "react-bootstrap";
import { ClipLoader } from "react-spinners";
import $ from "jquery";
import MediaQuery from "react-responsive";
import "animate.css/animate.min.css";
import ScrollAnimation from "react-animate-on-scroll";
import ReactPlayer from "react-player";
import emailForwardIcon from "../../images/icons/send-mail-icon.jpg";
import MailForwardForm from "../../components/MailForwardForm";

const icon1 = "https://winpeforum.com/assets/elements/kyra-anoushka.png";

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
      style={{ margin: "0% auto 0px" }}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div className="item_des">{activeItem.post}</div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};
TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SuhelaKhan extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      activeItem: {},
      isShow: false,
      activeKeyword: "",
      isSearching: false,
      lastCounter: 3,
      activeTitle: "SORT BY",
      activeSortBy: "default",
      showMailShareForm: false,
    };
    this.betterContent = insightsConstants;
     
    this.Speaker = [
      {
        desc: `<div> 
        </div>`,
        name: "Anoushka Menezes & Kyra Menezes",
        post: "Grade 12 Student",
        imgUrl: icon1,
        head: "Entrepreneurship Is Still a Boys’ Club",
      },
    ];
  }
  componentDidMount() {
    // function sticky_relocate () {
    // 	var window_top = $(window).scrollTop()
    // 	var div_top = $("#sticky-anchor").offset().top
    // 	if (window_top > div_top) {
    // 		$("#sticky").addClass("stick")
    // 	} else {
    // 		$("#sticky").removeClass("stick")
    // 	}
    // }
    // $(function () {
    // 	$(window).scroll(sticky_relocate)
    // 	sticky_relocate()
    // })
  }

  toggleMailShareForm = () => {
    this.setState({ showMailShareForm: !this.state.showMailShareForm });
  };

  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  handleMenu = (item) => {
    this.setState({
      activeTitle: item.title,
    });

    let leftlist = [...insightsConstants];
    this.betterContent = [];
    if (item.title === "SORT BY") {
      []
        .concat(leftlist)
        // .filter((a) => a.r_type === "Appetizer")
        .forEach((item, i) => this.betterContent.push(item));
    } else if (item.title === "ALL") {
      []
        .concat(leftlist)
        // .filter((a) => a.r_type === "Appetizer")
        .forEach((item, i) => this.betterContent.push(item));
    } else {
      []
        .concat(leftlist)
        .filter((insight) => {
          console.log(insight);
          // a.typee.indexOf(item.title) >= 0}
          let flag = false;
          for (let i = 0; i < insight.itype.length; i++) {
            if (item.title === insight.itype[i]) {
              flag = true;
            }
          }
          return flag;
        })
        .forEach((item, i) => this.betterContent.push(item));
    }
    this.setState({
      activeSortBy: item.title,
    });
    setTimeout(() => {
      this.setState({
        isSearching: false,
      });
    }, 1000);
  };
  handleSearch = (e) => {
    let str = e.target.value.length ? e.target.value.toLowerCase().trim() : "";
    this.setState({
      isSearching: true,
      activeKeyword: str,
    });
    let leftlist = [...insightsConstants];
    this.betterContent = [];
    leftlist.forEach((item) => {
      if (
        item.skey
          .toLowerCase()
          .trim()
          .search(str) > -1
      ) {
        this.betterContent.push(item);
      }
    });
    setTimeout(() => {
      this.setState({
        isSearching: false,
      });
    }, 1000);
  };
  render() {
     

    const {
      defaultStyle,
      isSearching,
      isShow,
      activeTitle,
      activeSortBy,
    } = this.state;
    const { location } = this.props;
    return (
      <div>
         
        <ContentPage>
        <Meta
          title="Entrepreneurship Is Still a Boys’ Club"
          image={"https://winpeforum.com/assets/elements/WinPE_Home_Page_link_image1.jpg"}
          description="In the 2020s, women continue to be shortchanged in the world of entrepreneurship, despite their growing drive to build their own businesses. While statistics trumpet their increased hustling, they receive a mere 2% of venture capital. This isn’t just unfair; it’s detrimental to the economy. "
          location={location}
        />
          <div className="section__content">
            <div className="insights_wrapper">
              <div className="insights_section">
                
                <div className="insights_content">
                  <div className="drop_src_box">
                   
                  
                  
                  </div>
                  <div className="insights_mid_section">
                    <div className="row">
                      
                     
                      <div className="col-lg-12 col-md-12">
                        <ScrollAnimation
                          delay={0}
                          duration={2}
                          animateIn="slideInRight"
                          offset={600}
                        >
                          <div className="insights_right_text">
                            <div className="insights_blog_page">
                            <br/><br/><br/><br/>
                              <div className="insights_blog_text">
                                {this.Speaker.map((item, i) => {
                                  return (
                                    <div className="row">
                                      <ScrollAnimation
                                        delay={0}
                                        duration={1}
                                        animateIn="zoomIn"
                                        offset={100}
                                      >
                                        <div className="col-md-3 col-sm-6">
                                          <div
                                            className="right_img_section"
                                             
                                          >
                                            <img
                                              src={item.imgUrl} style={{width:'100%'}}
                                              alt="Suhela khan"
                                              className="img-responsive"
                                            />
                                          </div>
                                        </div>
                                        <div className="col-md-9 col-sm-6">
                                          <div className="right_name_section">
                                            <div className="r_head">
                                              {item.head}
                                            </div>
                                            <div className="r_name">
                                              {item.name}
                                            </div>
                                            <div className="r_post">
                                            Grade 12 Student </div>
                                            <div className="r_block">
                                              <span> </span> &#8226; 6
                                              mins read
                                            </div>
                                          </div>
                                          <div className="share_section_one">
                                            <div className="headsocialLink">
                                           
                                             
                                           
                                              
                                            </div>
                                          </div>
                                        </div>
                                      </ScrollAnimation>
                                    </div>
                                  );
                                })}
                              </div>
                              <div className="insights_blog_text_btm">
                                <div className="text_section">
                                  <div className="into_text" style={{fontStyle:'normal'}}>
                                    
              <div className=" " style={{textAlign:'left'}}>
              In the 2020s, women continue to be shortchanged in the world of entrepreneurship, despite their growing drive to build their own businesses. While statistics trumpet their increased hustling, they receive a mere 2% of venture capital. This isn’t just unfair; it’s detrimental to the economy. Across all levels, the data shows the untapped potential of women-owned businesses and an urgent need to overcome systemic biases.
<br/><br/>
Gender disparities in entrepreneurship extend to India as well, as shown by the 2021 Mastercard Index of Women Entrepreneurs. Classified as an underperformer, India showcased a significant lag in facilitating the professional advancement of women business leaders. Alarmingly, India stands at the 59th position among 65 countries with women entrepreneurs, with women accounting for a 6% share of all business owners. India’s sub-optimal footing underscores the importance of addressing systemic barriers to ensure a more inclusive and equitable entrepreneurial ecosystem.
<br/><br/>
Challenges for women in entrepreneurship are manifold, including access to funding. Harvard Business School reports a striking bias in investor preferences, revealing that pitches by men are more likely to secure funding compared to those by women. This bias is influenced by factors such as physical attractiveness despite identical pitch content, illustrating the deep-seated challenges women face in securing funding.
<br/><br/>
Inversely, the benefits of women entrepreneurs in the business landscape are numerous. Forbes emphasises the unique perspectives proffered by women, particularly in developing services tailored to the needs of women. Research further highlights women’s prowess as collaborators and skilled multitaskers. An Australian study from 2019–2020, as reported by Inside Ageing, reveals that for every dollar of funding, female-founded startups made 78 cents, surpassing male-founded startups, which made just 31 cents. Data from the Court of Arbitration of the European Chamber of Digital Commerce shows that women-owned firms not only generate significantly higher revenue but also showcase superior effectiveness in senior leadership roles.
<br/><br/>
In conclusion, the persisting disparity in venture capital funding for male and female entrepreneurs signals not only an economic challenge but a missed opportunity for innovation and growth. Systemic biases unveiled in investor preferences also demand a comprehensive reevaluation of gender inclusivity in the investing world to foster a more inclusive entrepreneurial environment. Despite the numerous benefits that women entrepreneurs have demonstrated, these advantages remain underutilised. Moving forward, dismantling barriers and improving women’s access to capital are imperative for a thriving entrepreneurial landscape.
<br/><br/>
Author
<br/>
Anoushka Menezes & Kyra Menezes<br/>

Grade 12 Student
<br/><br/><br/>
<h4>Source:</h4>
<ul>
    <li>Pitchbook 2022 Female Founders Year in Review, December 18, 2022.</li>

    <li>Niti Aayog Report,“Decoding government support to women entrepreneurs in India”,October 2022.</li>

    <li>Mastercard Report, “The Mastercard Index of Women Entrepreneurs,” March 2022.</li>

    <li>BCG Report, “Why women owned startups are a better bet”, June 2018.

</li>
</ul>
              </div>






                                  </div>
                                 
                                 
                                  <div className="r_text_Q"></div>
                                  <div className="r_text_Q"></div>
                                  {/* <div className="r_text">
                                    <div
                                      className="para"
                                      style={{ padding: "20px 0px 0px 0px" }}
                                    >
                                      <i>Interviewed by Sreeja Vasantham</i>
                                    </div>
                                  </div> */}
                                </div>
                             
                              </div>
                      
                            </div>
                          </div>
                        </ScrollAnimation>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <TeamModal
                show={isShow}
                onHide={this.togglePopUp}
                activeItem={this.state.activeItem}
              />
            </div>
          </div>
        </ContentPage>
      </div>
    );
  }
}
SuhelaKhan.propTypes = {
  location: PropTypes.object,
};

export default SuhelaKhan;



// WEBPACK FOOTER //
// ./src/pages/Entrepreneurship-Is-Still-a-Boys-Club/index.js